module.exports = __webpack_public_path__ + "img/eicon1.91fb105c.png";